<template>
  <div>
    <div v-if="isAgent() || isAdmin()">
          <history-analysis :editable="true"/>
    </div>
    <div v-if="isSeller()">
          <history-analysis :editable="false"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseView from '@/views/BaseView';
import HistoryAnalysis from '@/components/analysis/HistoryAnalysis';

export default {
  mixins: [BaseView],
  created() { this.updateTitle('過去データ'); },
};

Vue.component('history-analysis', HistoryAnalysis);
</script>

<style>
.tab-margin {
  margin-top: 1rem;
}
</style>
